export default "__VITE_ASSET__BVR7coFx__"